import request from '@/utils/request'

/**
 * 生成验证码
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function generateValidateCode(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/login.generatorValidateCode',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 用户登录
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function login(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/login.supplyChainUserLogin',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}